export default __webpack_public_path__ + "static/media/Chevrolet.3552e494.svg";